module.exports = __webpack_public_path__ + "img/layer3_00001.d653ed1b.png";